import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import fire from "../config/Fire";
import IconButton from "@material-ui/core/IconButton";
import DownloadIcon from "@material-ui/icons/ArrowDownward";
import Load from "@material-ui/icons/ArrowDropDownCircle";
import { CSVLink } from "react-csv";

const styles = {
  root: {
    flexGrow: 1
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  }
};

class ButtonAppBar extends React.Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
    this.consulta = this.consulta.bind(this);
    this.state = {
      datos: []
    };
  }
  logout() {
    fire.auth().signOut();
  }
  consulta() {
    fire
      .database()
      .ref()
      .child("users")
      .on("child_added", snapshot => {
        this.setState({
          datos: this.state.datos.concat(snapshot.val())
        });
      });
  }
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <AppBar
          style={{ background: "#1A1A1F", boxShadow: "none" }}
          position="static"
        >
          <Toolbar>
            <Typography variant="h6" color="inherit" className={classes.grow}>
              Alan Saldaña
            </Typography>
            <IconButton
              aria-label="Delete"
              color="primary"
              className={classes.margin}
              onClick={this.consulta}
            >
              <Load color="primary" />
            </IconButton>
            <CSVLink data={this.state.datos}>
              {" "}
              <DownloadIcon color="primary" />
            </CSVLink>
            <Button color="inherit" onClick={this.logout}>
              Cerrar sesión
            </Button>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

ButtonAppBar.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ButtonAppBar);